export type TerminalThemeName =
  | "oxblood"
  | "wine"
  | "midnight"
  | "cream"
  | "pink";

export interface TerminalTheme {
  frame: string;
  chrome: string;
  chromeText: string;
  accent: string;
  accentSoft: string;
  cmdBoxBg: string;
  cmdBoxBorder: string;
  btnBg: string;
  btnText: string;
  pillBg: string;
}

export const TERMINAL_THEMES: Record<TerminalThemeName, TerminalTheme> = {
  oxblood: {
    frame: "bg-[#1a0a0a] text-tgc-cream border-white/15",
    chrome: "bg-black/40 border-white/10",
    chromeText: "text-tgc-cream/55",
    accent: "#a72913",
    accentSoft: "#ecd6d2",
    cmdBoxBg: "rgba(0,0,0,0.4)",
    cmdBoxBorder: "#a72913",
    btnBg: "#a72913",
    btnText: "#fffcef",
    pillBg: "rgba(255,252,239,0.1)",
  },
  cream: {
    frame: "bg-tgc-cream text-tgc-ink border-tgc-oxblood/20",
    chrome: "bg-[#f4ead8] border-tgc-oxblood/15",
    chromeText: "text-tgc-oxblood/60",
    accent: "#a72913",
    accentSoft: "#571310",
    cmdBoxBg: "rgba(87,19,16,0.06)",
    cmdBoxBorder: "#a72913",
    btnBg: "#571310",
    btnText: "#fffcef",
    pillBg: "rgba(87,19,16,0.08)",
  },
  wine: {
    frame: "bg-tgc-wine text-tgc-cream border-white/10",
    chrome: "bg-black/30 border-white/10",
    chromeText: "text-tgc-cream/50",
    accent: "#c2858c",
    accentSoft: "#ecd6d2",
    cmdBoxBg: "rgba(0,0,0,0.3)",
    cmdBoxBorder: "#c2858c",
    btnBg: "#c2858c",
    btnText: "#1a0a0a",
    pillBg: "rgba(255,252,239,0.08)",
  },
  midnight: {
    frame: "bg-[#0d0d14] text-tgc-cream border-tgc-pink/30",
    chrome: "bg-black/50 border-white/08",
    chromeText: "text-tgc-cream/45",
    accent: "#a72913",
    accentSoft: "#edcd6d2",
    cmdBoxBg: "#473232",
    cmdBoxBorder: "#c2858c",
    btnBg: "#c2858c",
    btnText: "#0d0d14",
    pillBg: "rgba(194,133,140,0.12)",
  },
  pink: {
    frame: "bg-[#ecd6d2] text-tgc-ink border-tgc-pink/30",
    chrome: "bg-tgc-pink/20 border-tgc-pink/20",
    chromeText: "text-tgc-ink/50",
    accent: "#6d0016",
    accentSoft: "#571310",
    cmdBoxBg: "rgba(109,0,22,0.06)",
    cmdBoxBorder: "#6d0016",
    btnBg: "#6d0016",
    btnText: "#fffcef",
    pillBg: "rgba(109,0,22,0.08)",
  },
};
